import {crearHash} from "../Funciones/crearHash";
import {obtenerConsecutivo} from "../../Servicios/BD/Consecutivos/obtenerConsecutivo";
import {registrarMovimiento} from "../Movimientos/registrarMovimiento";
import {aumentarConsecutivo} from "../../Servicios/BD/Consecutivos/aumentarConsecutivo";
import {adap_retiro_mov} from "../Adaptadores/adap_retiro_mov";

export const realizarRetiroDeposito = async ({usuario, valor, desde}) => {


    let doxConsecutivo = await obtenerConsecutivo({col: 'consecutivos', id: 'movimientos'})

    let retiro = {
        nombre: usuario.nombre,
        codigo: usuario.codigo,
        correo: usuario.correo,
        valor: valor * -1,
        fecha: new Date().getTime(),
        idUsuario: usuario.id,
        consecutivo: doxConsecutivo.data,
        detalle: "Dinero trasladado a Wallet de Deposito",

    }

    retiro.desde = desde
    retiro.hashString = JSON.stringify(retiro)
    retiro.hash = crearHash({text: retiro.hashString})



    let dox = await registrarMovimiento({
        movimiento: adap_retiro_mov({usuario: usuario, compra: retiro, metodo: 'Wallet Deposito', billetera: "NA"}),
        estado: 'Aceptado',

    })

    await aumentarConsecutivo({col: 'consecutivos', id: 'movimientos', actual: retiro.consecutivo})

    return dox

}
